module.exports = __webpack_public_path__ + "img/footerinfinity.ed71d403.png";